export async function MountPDFViewer(props: any, el: Element) {
	const a = await import('./PDFViewer');
	a.MountPDFViewer(props, el);
}

(window as any).MountPDFViewer = MountPDFViewer;
